<template>
  <div class="empty-bookmarks-books">
    <div class="empty-bookmarks-books__content dea-bg-grey-light">
      <h3 class="empty-bookmarks-books__title dea-heading--regular__l">
        Qui troverai tutte le risorse e materiali didattici che aggiungerai ai preferiti.
      </h3>
      <div class="dea-heading--regular__m">
        Non perderti le risorse che pensi possano tornarti utili! Aggiungile ai preferiti mentre consulti uno dei
        <router-link class="dea-links " :class="`dea-links--${linkColor}`" :to="{ name: 'books' }">
          <span class="dea-links__label dea-heading--regular__m">tuoi libri</span>
        </router-link>
        o utilizzi un portale o uno strumento Deascuola!
      </div>
      <div class="empty-bookmarks-books__instruction">
        <div class="dea-heading--regular__m">
          Clicca (o, se stai usando uno smartphone o un tablet, tocca) l'icona della stella:
        </div>
        <div class="dea-ico-preferiti empty-bookmarks-books__icon"></div>
        <div class="dea-heading--regular__m">
          Diventerà scura
          <div class="dea-ico-preferiti empty-bookmarks-books__icon empty-bookmarks-books__icon--negative"></div>
          e il tuo contenuto sarà disponibile qui.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyEvents",
  props: {
    linkColor: {
      type: String,
      required: true,
    },
    aed: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_empty-section"; //sass-lint:disable-line clean-import-paths

.empty-bookmarks-books {
  @include empty-section;
  @include empty-section-bookmarks;
}
</style>
